import { WorkshopRequestDTO } from '../models/workshop-request';
import { IResult } from '../models/result-models';
import { apiPost } from './api-utils';

const baseUrl = process.env.REACT_APP_SERVICES_URL + '/forms/workshop';

export const submitWorkshopRequest = async (
    workshoprequest: WorkshopRequestDTO
): Promise<IResult<boolean>> => {
    const result = await apiPost<WorkshopRequestDTO, boolean>(
        `${baseUrl}`,
        workshoprequest
    );
    return result;
};
